import { Route } from '@angular/router';
import { DirectUserCompanyGuard } from '@app/shared/guards/direct-user-company.guard';
import { UrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { CompanyOshViewComponent } from '@app/views/company/company-osh/company-osh-view.component';
import { cooperationsRoutes } from '@app/views/company/cooperations/cooperations.routing';
import { draftProjectsRoutes } from '@app/views/company/draft-projects/draft-projects.routing';
import { groupsRoutes } from '@app/views/company/groups/groups.routing';
import { industriesRoute } from '@app/views/company/industries/industries.routing';
import { CompanyActiveProjectsViewComponent } from '@app/views/company/projects/company-projects/company-active-projects/company-active-projects-view.component';
import { CompanyArchivedProjectsViewComponent } from '@app/views/company/projects/company-projects/company-archived-projects/company-archived-projects-view.component';
import { CompanyDraftProjectsViewComponent } from '@app/views/company/projects/company-projects/company-draft-projects/company-draft-projects-view.component';
import { CompanyProjectsViewComponent } from '@app/views/company/projects/company-projects/company-projects-view.component';
import { projectsRoutes } from '@app/views/company/projects/projects.routing';
import { usersRoutes } from '@app/views/company/users/users.routing';

export const companyRoute: Route[] = [
  {
    path: UrlSegment.FILES,
    loadComponent: () => import('./files/company-files-view.component').then(module => module.CompanyFilesViewComponent)
  },
  {
    path: UrlSegment.INDUSTRIES,
    loadChildren: () => industriesRoute,
    canActivate: [DirectUserCompanyGuard]
  },
  {
    path: UrlSegment.USERS,
    loadChildren: () => usersRoutes,
    canActivate: [DirectUserCompanyGuard]
  },
  {
    path: UrlSegment.GROUPS,
    loadChildren: () => groupsRoutes,
    canActivate: [DirectUserCompanyGuard]
  },
  {
    path: UrlSegment.COOPERATIONS,
    loadChildren: () => cooperationsRoutes,
    canActivate: [DirectUserCompanyGuard]
  },
  {
    path: UrlSegment.PROJECTS,
    loadChildren: () => projectsRoutes
  },
  {
    path: UrlSegment.OSH,
    component: CompanyOshViewComponent
  },
  {
    path: UrlSegment.PROJECTS_LIST,
    component: CompanyProjectsViewComponent,
    children: [
      {
        path: '',
        redirectTo: UrlSegment.ACTIVE,
        pathMatch: 'full'
      },
      {
        path: UrlSegment.ACTIVE,
        component: CompanyActiveProjectsViewComponent
      },
      {
        path: UrlSegment.ARCHIVED,
        component: CompanyArchivedProjectsViewComponent
      },
      {
        path: UrlSegment.DRAFTS,
        component: CompanyDraftProjectsViewComponent
      }
    ]
  },
  {
    path: UrlSegment.DRAFT_PROJECTS,
    loadChildren: () => draftProjectsRoutes
  },
  { path: '**', redirectTo: UrlSegment.PROJECTS_LIST + '/' + UrlSegment.ACTIVE }
];
